module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (2).a964e55e.jpg";